import { useEffect, useRef, useCallback } from "react";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";

export function useTerminal(termRef) {
  const termInstance = useRef(null);
  const fitRef = useRef(null);

  useEffect(() => {
    if (termInstance.current) return;
    if (!termRef.current) return;

    const term = new Terminal({
      cursorBlink: true,
      convertEol: true,
      scrollback: 1000,
      theme: {
        background: "#000",
        foreground: "#00ff00",
      },
      fontSize: 18,
      fontFamily: "monospace",
    });

    const fit = new FitAddon();
    term.loadAddon(fit);

    term.open(termRef.current);
   /* 
    const onData = useCallback((cb) => {
  const term = termInstance.current;
  if (!term) return () => {};
  const sub = term.onData((data) => {
  const sub = term.onData((data) => {
  console.log("TERMINAL BYTE:", JSON.stringify(data));
  cb(data);
});
    cb(data); // raw terminal bytes
  });
  return () => sub.dispose();
}, []);
*/

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fit.fit();
      });
    });

    termInstance.current = term;
    fitRef.current = fit;

    const onResize = () => {
      requestAnimationFrame(() => {
        fitRef.current?.fit();
      });
    };

    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      term.dispose();
      termInstance.current = null;
      fitRef.current = null;
    };
  }, []);


const write = useCallback((data = "") => {
  termInstance.current?.write(String(data));
}, []);

const writeln = useCallback((data = "") => {
  termInstance.current?.writeln(String(data));
}, []);

const getTerminal = useCallback(() => termInstance.current, []);

  const clear = useCallback(() => {
    termInstance.current?.clear();
  }, []);

  const onData = useCallback((cb) => {
    const term = termInstance.current;
    if (!term) return () => {};

    const sub = term.onData(cb);
    return () => sub.dispose();
  }, []);

  return {
    write,
    writeln,
    clear,
    onData,
    getTerminal,
  };
}